import { render } from "./STGView.vue?vue&type=template&id=3adf3e2c"
import script from "./STGView.vue?vue&type=script&lang=js"
export * from "./STGView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__